import React, { useState, useEffect } from 'react';
import { Card, Tabs, message } from 'antd';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import ApplyLoan from './ApplyLoan';
import LoanStatus from './LoanStatus';
import ManageLoans from './ManageLoans';

const { TabPane } = Tabs;

const LoanMain = () => {
    const [userRole, setUserRole] = useState('employee');
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Get user information from localStorage
        const currentUserId = localStorage.getItem('userId');
        const userPermissions = localStorage.getItem('permissions');
        const userRoleFromStorage = localStorage.getItem('userRole');
        
        setUserId(currentUserId);
        
        // Determine user role based on permissions
        if (userPermissions && userPermissions.includes('readAll-attendance')) {
            if (userRoleFromStorage === 'Admin' || userRoleFromStorage === 'Administrator') {
                setUserRole('admin');
            } else if (userRoleFromStorage === 'HR' || userRoleFromStorage === 'Human Resource') {
                setUserRole('hr');
            } else {
                setUserRole('manager');
            }
        } else {
            setUserRole('employee');
        }
        
        setLoading(false);
    }, []);

    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    const renderTabs = () => {
        const tabs = [];

        // Apply Loan tab - available for all users
        tabs.push(
            <TabPane tab="Apply Loan" key="apply">
                <ApplyLoan userRole={userRole} userId={userId} />
            </TabPane>
        );

        // Loan Status tab - available for all users
        tabs.push(
            <TabPane tab="Loan Status" key="status">
                <LoanStatus userRole={userRole} userId={userId} />
            </TabPane>
        );

        // Manage Loans tab - only for admin/HR
        if (userRole === 'admin' || userRole === 'hr') {
            tabs.push(
                <TabPane tab="Manage Loans" key="manage">
                    <ManageLoans />
                </TabPane>
            );
        }

        return tabs;
    };

    const getPageTitle = () => {
        switch (userRole) {
            case 'admin':
                return 'Loan Management (Admin)';
            case 'hr':
                return 'Loan Management (HR)';
            case 'manager':
                return 'Loan Management (Manager)';
            default:
                return 'Loan Management';
        }
    };

    return (
        <>
            <PageTitle title='Back' />
            <Card title={getPageTitle()}>
                <Tabs defaultActiveKey="apply" type="card">
                    {renderTabs()}
                </Tabs>
            </Card>
        </>
    );
};

export default LoanMain;
